var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullScreen37(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 448c-17.7 0-32-14.3-32-32V192c0-53 43-96 96-96h224c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32 14.3-32 32v224c0 17.7-14.3 32-32 32zM896 448c-17.7 0-32-14.3-32-32V192c0-17.7-14.3-32-32-32H608c-17.7 0-32-14.3-32-32s14.3-32 32-32h224c53 0 96 43 96 96v224c0 17.7-14.3 32-32 32zM128 576c-17.7 0-32 14.3-32 32v224c0 53 43 96 96 96h224c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32-14.3-32-32V608c0-17.7-14.3-32-32-32zM896 576c-17.7 0-32 14.3-32 32v224c0 17.7-14.3 32-32 32H608c-17.7 0-32 14.3-32 32s14.3 32 32 32h224c53 0 96-43 96-96V608c0-17.7-14.3-32-32-32z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen37);
export default __webpack_public_path__ + "static/media/full-screen-37.9faff3a92916422b0e37b31e77fef8ce.svg";
export { ForwardRef as ReactComponent };